<template>
  <Modal>
    <Modal.Title>{{ title }}</Modal.Title>
    <Modal.Body>
      <IAPBody :type="type" />
    </Modal.Body>
    <Modal.Footer>
      <Button variant="primary" :size="isMobile ? 'lg' : 'md'" @click="close()">
        Okay
      </Button>
    </Modal.Footer>
  </Modal>
</template>

<script setup lang="ts">
import { Modal, Button, useModal } from '@dacr/library'

import { useDevice } from '@/shared/composables/useDevice'
import IAPBody from './IAPBody.vue'
import { useIAP, type IAPType } from './useIAP'

const props = defineProps<{
  type: IAPType
}>()

const { close } = useModal()
const { isMobile } = useDevice()
const { title } = useIAP(props.type)
</script>
